
// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { Empenho } from './empenho.model';
import { Exercicio } from '../comum/exercicio.model';
import { Orgao } from '../comum/orgao.model';
import { Usuario } from '../comum/usuario.model';
import { Liquidacao } from './liquidacao.model';

export class PreLiquidacao extends BaseResourceModel {
    constructor(
        public id?: number,
        public data_liquidacao?: Date,
        public mes?: number,
        public data_vencimento?: Date,
        public parcela?: number,
        public data_referencia?: Date,
        public documento?: string,
        public historico?: string,
        public valor_liquidado?: number,
        public impresso?: boolean,
        public anulacao?: boolean,
        public empenho?: Empenho,
        public exercicio?: Exercicio,
        public orgao?: Orgao,
        public usuario_cadastro?: Usuario,
        public serie?: string,
        public data_emissao?: Date,
        public liquidacoes?: Liquidacao[],
        public preliquidacao_anulada?: PreLiquidacao,
        public anulado_total?: boolean,
        public tipo_documento?: string,
    ) {
        super();
    }

    static converteJson(json: any): PreLiquidacao {
        return Object.assign(new PreLiquidacao(), json);
    }
}
